module.exports = __webpack_public_path__ + "img/CousinUndCousine.7f6258af.svg";